import React, { useEffect, useState } from "react";
import title from "../../images/integration/TrafficAnalyzer.png";
import Parameters from "shared/components/Parameters";
import Layout from "../../components/Layout";
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";
import { parseImagesModule } from "shared/utils/utils.js";


export function Page({ openPopup }) {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const modules = import.meta.glob('../../images/integration/presentationTA/*.{png,jpg,jpeg,webp,avif}', {
      eager: true,
      import: 'default'
    })
    const images = parseImagesModule(modules)
    images.sort((i1, i2) => +i1.name.replace('Page', '') - +i2.name.replace('Page', ''))
    setImages(images)
  }, [])
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <div className="d-flex justify-content-between flex-wrap">
            <h1 className="mb-4 ">
              Регистратор событий ЦПС (NPT Traffic Analyzer)
            </h1>
            <MinDigitsBrand id="2839897" />
          </div>

          <Parameters
            title=""
            image={title}
            images={images}
            openPopup={openPopup}
            zoomColor="white"
          >
            <h5 className="mb-3"><b>Регистратор событий ЦПС (PC ЦПС)</b> - программно-аппаратный
              комплекс, выполняющий функцию анализа сетевого трафика шины станции и
              шины процесса.</h5>

            <h5 className="mb-3"><b>Регистратор событий ЦПС</b> реализован в соответствии с СТО ПАО "ФСК ЕЭС" 56947007-29.240.10.302-2020 "Типовые технические требования к организации и производительности технологических ЛВС в АСУ ТП ПС ЕНЭС" и выполняет следующие функции:</h5>
            <ul>
              <li>анализ данных стандарта МЭК 61850 GOOSE, МЭК 61850-9-2 и корпоративного профиля МЭК 61850 ПАО «ФСК ЕЭС» на предмет соответствия электронному проекту (SCD-файлу);</li>
              <li>контроль параметров передачи SV-потоков и GOOSE-сообщений;
                - анализ конфигурации информационной сети на соответствие SCD файлу;</li>
              <li>мониторинг ошибок на предмет потери или искажения пакетов;</li>
              <li>анализ загруженности ЛВС;</li>
              <li>отображение всех SV-потоков и GOOSE-сообщений в ЛВС;</li>
              <li>регистрация и хранение собранной информации;</li>
              <li>выдача обобщенной сигнализации в АСУ ТП.</li>
            </ul>
            <a className="text-links" href="https://epsa-spb.ru/kontakty-2/">Запросить референс лист</a>
          </Parameters>
        </div>
      </div>
    </Layout>

  );
}

